import { MESSAGE_TYPES_MAP } from "../data/messageTypes"
import { ORDER_TRANSACTION_STATUS, PAYMENT_METHODS } from "../data/static.items"

const typePolicies = {
  RouteAssignmentType: {
    fields: {
      rrules: {
        read(existing) {
          try {
            return JSON.parse(existing)?.recurrence_rules
          } catch (err) {
            console.error(err, "UNABLE TO PARSE RRULE")
            return null
          }
        },
      },
    },
  },
  TripHistorySummary: {
    fields: {
      averageSpeed: {
        read(averageSpeed) {
          // Return the cached averageSpeed, rounded up
          return Math.round(averageSpeed)
        },
      },
      distance: {
        read(distance) {
          return Math.ceil(distance)
        },
      },
      averageWaitTime: {
        read(averageWaitTime) {
          return averageWaitTime
        },
      },
    },
  },
  UserFilterType: {
    fields: {
      value: {
        read(value) {
          if (typeof value === "string") {
            return []
          }
          return value
        },
      },
    },
  },
  NotificationType: {
    fields: {
      messegeType(value) {
        return MESSAGE_TYPES_MAP[value]
      },
    },
  },
  BookingType: {
    fields: {
      unsettledSkus(value) {
        return value || 0
      },
    },
  },
  OrderTransactionType: {
    fields: {
      paymentMethod(value) {
        return PAYMENT_METHODS.find(p => p.id === value)
      },
      status(value) {
        return ORDER_TRANSACTION_STATUS.find(o => o.id === value)
      },
    },
  },
}
export default typePolicies
